import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { to: '/', label: '首页' },
    { to: '/category/dongzuo', label: '电影分类' },
    { to: '/about', label: '关于我们' },
  ];

  const categoryLinks = [
    { to: '/category/dongzuo', label: '动作片' },
    { to: '/category/xiju', label: '喜剧片' },
    { to: '/category/kehuan', label: '科幻片' },
    { to: '/category/dongman', label: '动漫' },
  ];

  const variantLinks = [
    { label: '7777影院' },
    { label: '777777影院' },
    { label: '77777影院' },
    { label: '7777777影院' },
  ];

  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="inline-block mb-4">
              <span className="text-lg font-bold text-foreground-950">
                777<span className="text-primary-500">影院</span>
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              777影院官网提供7777影院、777777影院、77777影院等数字变体统一入口，帮助用户快速进入官方首页，免费观看高清电影和电视剧全集。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">快速导航</h4>
            <ul className="flex flex-col gap-2">
              {quickLinks.map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">热门分类</h4>
            <ul className="flex flex-col gap-2">
              {categoryLinks.map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">数字变体入口</h4>
            <ul className="flex flex-col gap-2">
              {variantLinks.map((link) => (
                <li key={link.label}>
                  <span className="text-sm text-foreground-600">{link.label}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {currentYear} 777影院官网 版权所有 | 本站为影视导航入口，不存储任何视频内容
          </p>
          <p className="text-xs text-foreground-500">
            7777影院 · 777777影院 · 77777影院 · 7777777影院
          </p>
        </div>
      </div>
    </footer>
  );
}